export const goingFrames = {
  ways: {
    start: 0,
    end: 3,
  },
  frameRate: 6,
  repeat: -1,
};

export const fightFrames = {
  ways: {
    start: 0,
    end: 22,
  },
  frameRate: 15,
  repeat: -1,
};
